import { render } from "./DroppingPlace.vue?vue&type=template&id=39b3a77a&scoped=true"
import script from "./DroppingPlace.vue?vue&type=script&lang=js"
export * from "./DroppingPlace.vue?vue&type=script&lang=js"

import "./DroppingPlace.vue?vue&type=style&index=0&id=39b3a77a&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b3a77a"]])

export default __exports__